import React from "react";

import "./ContentGrid.css";

export default function ContentGrid({
  items = [],
  renderItem,
  loading = false,
  columns = 5,
  tabletColumns = 3,
  mobileColumns = 2,
  gap = 16,
  skeletonCount = 8,
  showEmpty = false,
  emptyMessage = "No content available.",
  className = "",
}) {
  const data = Array.isArray(items) ? items : [];
  const hasItems = data.length > 0;
  const showSkeletons = loading && !hasItems;

  const gridStyle = {
    "--content-grid-columns": Math.max(1, Number(columns) || 1),
    "--content-grid-tablet-columns": Math.max(1, Number(tabletColumns) || 1),
    "--content-grid-mobile-columns": Math.max(1, Number(mobileColumns) || 1),
    "--content-grid-gap": typeof gap === "number" ? `${gap}px` : gap,
  };

  if (!hasItems && !loading) {
    return showEmpty ? (
      <div className="katch-content-grid__empty">
        <p>{emptyMessage}</p>
      </div>
    ) : null;
  }

  return (
    <div
      className={`katch-content-grid-container ${className}`.trim()}
      style={gridStyle}
      aria-busy={showSkeletons}
    >
      <div className="katch-content-grid">
        {showSkeletons
          ? Array.from({ length: skeletonCount }, (_, index) => (
              <div
                key={`skeleton-${index}`}
                className="katch-content-grid__skeleton"
                aria-hidden="true"
              >
                <div className="katch-content-grid__skeleton-image" />
                <div className="katch-content-grid__skeleton-line" />
                <div className="katch-content-grid__skeleton-line katch-content-grid__skeleton-line--short" />
              </div>
            ))
          : data.map((item, index) => (
              <React.Fragment
                key={
                  item?.id ??
                  item?.videoId ??
                  item?.videoTag ??
                  item?.popId ??
                  item?.popTag ??
                  item?.albumId ??
                  item?.albumTag ??
                  item?.streamSessionId ??
                  item?.stream_session_id ??
                  index
                }
              >
                {renderItem?.(item, index)}
              </React.Fragment>
            ))}
      </div>
    </div>
  );
}
